<template>
  <div>
    <input
      class="outlined"
      @input="search($event.target.value)"
      v-model="history_company_name"
      placeholder="History Company"
    />
    <div
      v-if="history_companies_search_results.length > 0 && history_companies_search_results[0] != undefined"
      class="search_results"
    >
      <div
        style="margin: 0;"
        :key="'history_company_' + (history_company == undefined ? '0' : history_company.id)"
        @click="selectHistoryCompany(history_company)"
        v-for="history_company in history_companies_search_results"
      >
        <div v-if="history_company != undefined" class="search_result is-flex is-align-items-center is-justify-content-space-between"
          :class="{ create_new_result: history_company.is_create }">
          <span v-if="history_company.is_create">צור חדש</span>
          <span v-else>{{ history_company.name }}</span>
          <div v-if="is_creating" class="loading"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'history-companies-search-box',
  props: ['selected_history_company_name'],
  data () {
    return {
      history_companies_search_results: [],
      history_company_name: this.selected_history_company_name == undefined ? '' : this.selected_history_company_name,
      is_creating: false
    }
  },
  methods: {
    search (keyword) {
      if (keyword.length == 0) {
        this.history_companies_search_results = []
        return
      }
      this.$network_utils.searchHistoryCompany({ current_resource_id: 1, current_type: 'Applicant', search_term: keyword }).then(response => {
        this.history_companies_search_results = response
        this.history_companies_search_results.push({
          name: keyword,
          is_create: true,
          id: 0
        })
      })
    },
    selectHistoryCompany (history_company) {
      if (history_company.is_create) {
        this.createHistoryCompany(history_company)
        return
      }
      this.history_company_name = history_company.name
      this.history_companies_search_results = []
      this.$emit('input', history_company.id)
      this.$emit('selected', history_company)
    },
    createHistoryCompany (history_company) {
      this.is_creating = true
      this.$network_utils.postHistoryCompany({ name: history_company.name }).then((response) => {
        this.selectHistoryCompany(response)
        this.is_creating = false
      })
    }
  }
}
</script>
<style scoped>
  .create_new_result {
    color: white;
    background-color: var(--color-text);
  }
</style>
